import { vaultRequest } from './request';

const ME_QUERY = `
query Me {
  me {
    id
    email
    permissions
  }
}
`;

export const getMe = async (): Promise<User> => {
  const meInfoRes = await vaultRequest(ME_QUERY, {});
  const meInfoResJson = await meInfoRes.json();
  if (meInfoResJson.errors && meInfoResJson.errors.length > 0) {
    throw new Error('Could not get current user information');
  }
  return meInfoResJson.data?.me;
};
